import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  boxWrapper: {
    backgroundColor: palette.shades[200],
    position: 'relative'
  },
  actionsWrapper: {
    paddingTop: '32px'
  },
  actionBar: {
    '& .modal-trigger': {
      display: 'inline-block',
      width: '100%'
    },
    '& .MuiButton-action': {
      width: '100%'
    },
    [breakpointsFunc.breakpoints.down('lg')]: {
      '& .modal-trigger': {
        width: '100%'
      },
      '& .MuiButton-root': {
        width: '100%'
      }
    }
  }
});
export default useStyles;